import { useTranslation } from "react-i18next";
import { TWclassNames } from "../../utils/Div";
import { status } from "../../Utils";

export const projectParticipantsRole = [
  {
    id: "RESPONSIBLE",
    name: "RESPONSIBLE",
    value: "RESPONSIBLE",
    label: "Responsible",
    title: "Responsible",
  },
  {
    id: "RESPONSIBLE_EXECUTOR",
    name: "RESPONSIBLE_EXECUTOR",
    value: "RESPONSIBLE_EXECUTOR",
    label: "Responsible Executor",
    title: "Responsible Executor",
  },
  {
    id: "EXECUTOR",
    name: "EXECUTOR",
    value: "EXECUTOR",
    label: "Executor",
    title: "Executor",
  },
  {
    id: "OBSERVER",
    name: "OBSERVER",
    value: "OBSERVER",
    label: "Observer",
    title: "Observer",
  },
];

export const projectParticipantsStatus = [
  {
    value: "ASSIGNED",
    label: "Assigned",
    title: "Assigned",
  },
  {
    value: "ACCEPTED",
    label: "Accepted",
    title: "Accepted",
  },
  { value: "REJECTED", label: "Rejected", title: "Rejected" },
];

export const ProjectParticipantStatus = ({ participant }) => {
  const { t } = useTranslation();

  return (
    <span
      className={TWclassNames(
        participant?.status && !participant?.is_invoiced
          ? status[participant?.status]?.class
          : "",
        "inline-flex rounded-full px-2 text-xs font-semibold leading-5"
      )}
    >
      {participant?.is_invoiced ? (
        <span>Fakturert</span>
      ) : (
        <>
          {participant.status ? (
            <span>
              {" "}
              {t(status[participant?.status]?.label || participant?.status)}
            </span>
          ) : (
            <span className="bg-gray-100 inline-flex rounded-full px-2 text-xs font-semibold leading-5">
              {t("None")}
            </span>
          )}
        </>
      )}
    </span>
  );
};
